import { useId, useState } from "react";

const PLACEHOLDER_IMAGE = "/gallery/placeholder.svg";

export default function BeforeAfterSlider({
  before,
  after,
  title,
  heightClass = "h-64",
  onOpen,
  fallbackBefore = "",
  fallbackAfter = "",
}) {
  const [position, setPosition] = useState(50);
  const sliderId = useId();
  const handleImageError = (event, fallbackSrc) => {
    const image = event.currentTarget;
    if (fallbackSrc && image.dataset.fallbackTried !== "1") {
      image.dataset.fallbackTried = "1";
      image.src = fallbackSrc;
      return;
    }
    image.src = PLACEHOLDER_IMAGE;
  };

  return (
    <div>
      <button
        type="button"
        onClick={onOpen}
        className={`relative block w-full overflow-hidden rounded-2xl ${heightClass}`}
      >
        <img
          src={before}
          alt={`${title} Before`}
          className="h-full w-full object-cover"
          loading="lazy"
          onError={(event) => {
            handleImageError(event, fallbackBefore);
          }}
        />
        <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - position}% 0 0)` }}>
          <img
            src={after}
            alt={`${title} After`}
            className="h-full w-full object-cover"
            loading="lazy"
            onError={(event) => {
              handleImageError(event, fallbackAfter);
            }}
          />
        </div>

        <div className="pointer-events-none absolute inset-y-0" style={{ left: `${position}%` }}>
          <div className="h-full w-0.5 -translate-x-1/2 bg-white/90 shadow-[0_0_0_1px_rgba(15,35,64,0.12)]" />
          <div className="absolute left-1/2 top-1/2 grid h-9 w-9 -translate-x-1/2 -translate-y-1/2 place-content-center rounded-full border border-white/80 bg-white text-xs font-bold text-[#173d72] shadow-md">
            ⇆
          </div>
        </div>

        <span className="absolute bottom-3 left-3 rounded-full bg-[#153a6f]/90 px-3 py-1 text-xs font-semibold text-white">
          Before
        </span>
        <span className="absolute bottom-3 right-3 rounded-full bg-emerald-600/95 px-3 py-1 text-xs font-semibold text-white">
          After
        </span>
      </button>

      <label htmlFor={sliderId} className="sr-only">
        Before After Slider
      </label>
      <input
        id={sliderId}
        type="range"
        min="0"
        max="100"
        value={position}
        onChange={(event) => setPosition(Number(event.target.value))}
        className="mt-4 w-full accent-[#0f3d7a]"
      />
    </div>
  );
}
